import { jsxs as t, jsx as o } from "react/jsx-runtime";
const n = ({ className: r }) => /* @__PURE__ */ t(
  "svg",
  {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: r,
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M29.128 15.0184C29.1404 15.0184 29.1529 15.0183 29.1654 15.0183C33.3075 15.0183 36.6654 18.3824 36.6654 22.5321C36.6654 26.3996 33.7487 29.5847 29.9987 30M29.128 15.0184C29.1527 14.7434 29.1654 14.4649 29.1654 14.1835C29.1654 9.11158 25.0613 5 19.9987 5C15.2041 5 11.2692 8.68778 10.8661 13.3865M29.128 15.0184C28.9576 16.9126 28.2131 18.641 27.0701 20.0275M10.8661 13.3865C6.63867 13.7895 3.33203 17.3565 3.33203 21.6972C3.33203 25.7362 6.19496 29.1053 9.9987 29.8789M10.8661 13.3865C11.1291 13.3614 11.3958 13.3486 11.6654 13.3486C13.5417 13.3486 15.2733 13.9699 16.6662 15.0183",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M19.9987 21.6667L19.9987 35M19.9987 21.6667C18.8317 21.6667 16.6512 24.9905 15.832 25.8333M19.9987 21.6667C21.1657 21.6667 23.3461 24.9905 24.1654 25.8333",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
export {
  n as UploadCloudIcon
};
